module.exports = __webpack_public_path__ + "img/cover1.694757d1.png";